import * as Sentry from '@sentry/react-native';
import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { Linking } from 'react-native';

import { APPSFLYER_CONFIG } from '@/constants/config';
import { useEndFlowModal } from '@/contexts/endFlowModalContext';

import { createRedirect, deleteUser, signInWithEmail, validateRedirect } from '../functions/authQuery';

export const useSignInWithEmail = () => {
  const signInEmail = useMutation({
    mutationKey: ['sign-in-email'],
    mutationFn: signInWithEmail,
    onError: (e) => {
      console.error('Login with email failed', e);
      Sentry.captureException(e);
    }
  });

  return signInEmail;
};

export const useDeleteUser = () => {
  const { showError } = useEndFlowModal();
  return useMutation({
    mutationKey: ['delete-user'],
    mutationFn: deleteUser,
    onError: (e: any) => {
      showError({});
      console.error('Error deleting user', e);
    }
  });
};

export const useCreateRedirect = () => {
  const { showError } = useEndFlowModal();
  return useMutation({
    mutationFn: createRedirect,
    mutationKey: ['create-redirect'],
    onError: (e: any) => {
      showError({});
      console.error('Error creating redirect', e);
    }
  });
};

export const useValidateRedirect = () => {
  const { showError } = useEndFlowModal();
  return useMutation({
    mutationFn: validateRedirect,
    mutationKey: ['validate-redirect'],
    onError: (e: AxiosError) => {
      Sentry.captureException(e, {
        originalException: e,
        syntheticException: new Error('Failed to validate redirect from iOS'),
        mechanism: {
          handled: true,
          type: 'generic'
        }
      });
      const errorResponse = e.response as { data: { message?: string } };
      const params = new URLSearchParams({
        deep_link_value: 'donation',
        dismissBrowser: 'true'
      });
      const backRoute = `${APPSFLYER_CONFIG.af_dp}?${params.toString()}`;
      showError({
        title: e.message,
        message: errorResponse?.data?.message ?? 'Error validating redirect',
        onButtonPress: () => Linking.openURL(backRoute)
      });
      console.error('Error validating redirect', e);
    }
  });
};
